import styled from 'styled-components';
import { mediaBreakpointDown } from 'styles/grid';

const stepsMobileBreakpoint = mediaBreakpointDown.sm;

export const StepDownloadInstructionsContainer = styled.div`
  padding: 24px 32px;
  ${stepsMobileBreakpoint} {
    padding: 24px 10px;
  }
`;

export const HorizontalLine = styled.div`
  border: 1px solid;
  border-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.headerAndFooter.bgColor};
  width: 100%;
`;
